// FILE: pages/Login.js
import React, { useState, useEffect } from 'react';
import { auth, googleProvider, db } from '../firebase';
import { 
    signInWithEmailAndPassword, 
    signInWithPopup, 
    getRedirectResult 
} from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { doc, getDoc, setDoc } from 'firebase/firestore'; // Import Firestore functions

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const { currentUser } = useAuth();

    useEffect(() => {
        console.log('Checking for redirect result...');
        getRedirectResult(auth)
            .then((result) => {
                if (result?.user) {
                    console.log('User signed in via redirect:', result.user);
                    navigate('/');
                } else {
                    console.log('No redirect result.');
                }
            })
            .catch((error) => {
                console.error('Error handling redirect result:', error);
            });
    }, [navigate]);

    useEffect(() => {
        console.log('Checking current user:', currentUser);
        if (currentUser) {
            console.log('User already logged in:', currentUser);
            navigate('/');
        }
    }, [currentUser, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/');
        } catch (error) {
            console.error('Error logging in:', error);
        }
    };

    const handleGoogleLogin = async () => {
        console.log('Initiating Google sign-in...');
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;
            console.log("User signed in:", user);

            // Check if user exists in Firestore
            const userDoc = doc(db, "users", user.uid);
            const userDocSnapshot = await getDoc(userDoc);

            if (!userDocSnapshot.exists()) {
                // Add user information to Firestore
                await setDoc(userDoc, {
                    email: user.email,
                    uid: user.uid,
                    createdAt: new Date(),
                    role: "member" // Add role field
                });
                console.log('User information added to Firestore');
            } else {
                console.log('User already exists in Firestore');
            }

            navigate('/');
        } catch (error) {
            console.error("Error signing in:", error);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            <form onSubmit={handleLogin} className="bg-gradient-to-r from-green-400 to-teal-400 p-6 rounded shadow-md w-full max-w-sm">
                <h2 className="text-white text-2xl mb-4">Login</h2>
                <div className="mb-4">
                    <label className="block text-white font-light">Email</label>
                    <input 
                        type="email" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        className="text-black w-full p-2 border border-gray-300 rounded mt-1"
                        required 
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white font-light">Password</label>
                    <input 
                        type="password" 
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)} 
                        className="text-black w-full p-2 border border-gray-300 rounded mt-1"
                        required 
                    />
                </div>
                <button type="submit" className="w-full bg-teal-500 text-white p-2 rounded mb-4">Login</button>
                <button 
                    type="button" 
                    onClick={handleGoogleLogin} 
                    className="w-full bg-green-500 text-white p-2 rounded"
                >
                    Sign in with Google
                </button>
                <div className="mt-4 text-center">
                    <Link to="/register" className="text-white underline">Register</Link>
                    <br />
                    <Link to="/reset-password" className="text-white underline">Forgot Password?</Link>
                </div>
            </form>
        </div>
    );
};

export default Login;